export class CookiesKey {
  static readonly token = '__TOKEN'
  static readonly medicinesToCompare = '__MEDICINES_TO_COMPARE'
}

export const useCookies = () => {

  const setCookie = (key: string, value: string | null, options: {
    expires?: number | Date;
    path?: string;
    domain?: string;
    secure?: boolean
  } = {}) => {
    let cookieString = `${encodeURIComponent(key)}=${encodeURIComponent(value || '')}`;

    const expires =
      options.expires instanceof Date
        ? options.expires.toUTCString()
        : new Date(Date.now() + (options.expires ?? 730) * 1000 * 60 * 60).toUTCString();
    cookieString += `; expires=${expires}`;

    if (options.path) {
      cookieString += `; path=${options.path}`;
    }

    if (options.domain) {
      cookieString += `; domain=${options.domain}`;
    }

    if (options.secure) {
      cookieString += '; secure';
    }

    document.cookie = cookieString;
  };

  const getCookie = (key: string): string | null => {
    const cookies = document.cookie
      .split('; ')
      .reduce((acc: Record<string, string>, cookie) => {
        const [k, v] = cookie.split('=');
        acc[decodeURIComponent(k)] = decodeURIComponent(v || '');
        return acc;
      }, {});

    return cookies[key] || null;
  };

  return {setCookie, getCookie};
};